import express from 'express';
import { parsePayload } from '~/app/middleware';
import { migrateContentAssets } from '~/app/middleware/Assets';
import { callbackHandler } from '~/app/middleware/Callback';
import { migrateModels } from '~/app/middleware/ContentModels';
import { migrateContentTypes } from '~/app/middleware/ContentTypes';
import { migrateEntries } from '~/app/middleware/Entries';
import { migrateEverything } from '~/app/middleware/Everything';
import { migrateNodes } from '~/app/middleware/Nodes';
import { migrateTagGroups, migrateTags } from '~/app/middleware/Tags';
import { migrateWebhooks } from '~/app/middleware/Subscriptions';

const migrateRouter = express.Router();

migrateRouter.post(
  '/everything{/:preview}',
  parsePayload,
  migrateEverything,
  callbackHandler
);

migrateRouter.post(
  ['/components{/:preview}', '/contenttypes{/:preview}'],
  parsePayload,
  migrateContentTypes
);

migrateRouter.post('/models{/:preview}', parsePayload, migrateModels);

migrateRouter.post('/assets{/:preview}', parsePayload, migrateContentAssets);

migrateRouter.post(
  '/entries{/:preview}',
  parsePayload,
  migrateEntries,
  callbackHandler
);

migrateRouter.post(
  '/nodes{/:preview}',
  parsePayload,
  migrateNodes,
  callbackHandler
);

migrateRouter.post(
  '/taggroups{/:preview}',
  parsePayload,
  migrateTagGroups,
  callbackHandler
);

migrateRouter.post(
  '/tags{/:preview}',
  parsePayload,
  migrateTags,
  callbackHandler
);

migrateRouter.post(
  '/webhooks{/:preview}',
  parsePayload,
  migrateWebhooks,
  callbackHandler
);

export default migrateRouter;
